import React from 'react';
import { css } from '@emotion/core';

const miniShowWrapper = css`
  position: relative;
  width: 40%;
  display: inline-block;
  margin: 4px;
  white-space: initial;
  vertical-align: top;
`;

export class MiniShowPlaceholder extends React.PureComponent<any> {
  render() {
    return <div css={miniShowWrapper}>
    </div>;
  }
}

export default class MiniShow extends React.PureComponent {
  render() {
    let { poster, post: { post_title } } = this.props;

    if (poster.search('pbs.org') !== -1) {
      poster = `${poster}.resize.360x540.jpg`;
    }

    poster = poster.replace(/^http:/, 'https:');

    return <div css={miniShowWrapper}>
      <a className="mini-show-link" href={`/${this.props.post.post_name}/`} aria-label={post_title}>
        <img className="mini-show-poster" src={poster} alt={post_title} />
      </a>
    </div>;
  }
}